module.exports = __webpack_public_path__ + "static/media/download.bac31e39.svg";